import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { CDN_BASE_IMAGES_URL, STATIC_FAV_ICON } from "@constant";
// core components
import Header from "@mainheader";
import MainContainer from "@maincontainer";
import Footer from "@mainfooter";
import routes from "../routes";
import FourZeroFour from "../../src/components/common/pagenotfound";
import LocalStrings from "@language";
import MainLogin from "../components/social-promotion/main-login";
import {
  useLocalStorage,
  LOCAL_STORAGE,
  LOGIN_SCREEN_NAME,
} from "@useLocalStorage";

const Admin = (props) => {
  const { getLocalStorage } = useLocalStorage();
  const navigate = useNavigate();
  const location = useLocation();
  const { eventData, eventsettings, incorrectEvent = false } = props;
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [hideHeaderFooter, setHideHeaderFooter] = useState(false);
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const loginScreen = getLocalStorage(LOCAL_STORAGE.LOGIN_SCREEN);

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/register");
    }

    const offFeaderFooter = new URLSearchParams(location.search).get(
      "header_footer"
    );
    setHideHeaderFooter(offFeaderFooter === "off");
    if (location.pathname.includes("/badge")) {
      setHideHeaderFooter(true);
    }

    const validPath = routes.filter((route) => {
      return matchPath(route.path, location.pathname);
    });

    if (!incorrectEvent && eventData?.eventicon) {
      if (validPath?.length === 0) {
        setIsInvalidURL(true);
      }
    } else if (incorrectEvent) {
      setIsInvalidURL(true);
    }
  }, [eventData]);

  const handleScroll = () => {
    const firstColumn = document.getElementById("firstColumn");
    const trackerDiv = document.getElementById("scrollTracker");
    const trackerEndDiv = document.getElementById("scrollTrackerEnd");
    const stickyDiv = document.getElementById("stickyContent");
    const isMobile = window.innerWidth < 576;

    if (stickyDiv && firstColumn && !isMobile) {
      const rect = trackerDiv.getBoundingClientRect();
      const endElement = trackerEndDiv.getBoundingClientRect();
      const stickyHeight = stickyDiv.offsetHeight;
      const firstColumnHeight = firstColumn.offsetHeight;
      if (firstColumnHeight < stickyHeight) {
        firstColumn.style.height = `${stickyHeight}px`;
      }
      if (rect.top <= 0) {
        stickyDiv.classList.add("sticky-style");
        stickyDiv.style.height = `${endElement.top}px`;
        stickyDiv.style.width = `${trackerDiv.offsetWidth}px`;
      } else {
        stickyDiv.classList.remove("sticky-style");
        stickyDiv.style.height = ``;
        stickyDiv.style.width = ``;
      }
    }
  };
  const custom_settings = JSON.parse(
    eventsettings?.data?.custom_settings ?? "{}"
  );
  const isSocialEnabled =
    custom_settings?.socialboost_setting?.boostenabled ?? false;

  const showLogin =
    loginScreen === LOGIN_SCREEN_NAME.LAYOUT_SCREEN &&
    _.isEmpty(socialDetails) &&
    isSocialEnabled &&
    (location?.pathname?.includes("register") ||
      (location?.pathname?.includes("tickets") &&
        !location?.pathname?.includes("ticketorder")));

  const pageTitle = incorrectEvent
    ? LocalStrings.kNoPage
    : eventData?.eventname || "Event";

  const faviconHref = eventData?.eventicon
    ? `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`
    : STATIC_FAV_ICON;

  const ogImage = eventData?.eventicon
    ? `${CDN_BASE_IMAGES_URL}/${eventData?.eventicon}`
    : STATIC_FAV_ICON;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <link id="favicon" rel="icon" href={faviconHref} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {isInvalidURL ? (
        <>
          <FourZeroFour />
        </>
      ) : showLogin ? (
        <MainLogin />
      ) : (
        <div
          // onScrollCapture={handleScroll}
          style={{ height: window.innerHeight }}
        >
          {!hideHeaderFooter ? <Header /> : ""}

          <MainContainer routes={routes} hideHeaderFooter={hideHeaderFooter} />

          {!hideHeaderFooter ? <Footer /> : ""}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    eventData: state.eventData,
    eventsettings: state.eventSettingsData,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
